module.exports = function () {
    if ( !document.querySelector("form.sellforce") ) return;
    
    $("form.sellforce").validate({
        ignore: ".ignore",
        rules: {
            email: {
                required: true,
                email: true
            },
            hiddenRecaptcha: {
                required: function () {
                    if (grecaptcha.getResponse() == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {},
        submitHandler: function (form) {
            console.log('submit');
            // some other code
            // maybe disabling submit button
            // then:
            // form.submit();
            return true;
        }
    });


    if (showSpectrumHotTopics === 'show') {

        setTimeout(function () {

            var isPopupOpen = $('.widget--form').is(':visible');
            var isLoginPopupOpen = $('.popup_login').is(':visible');

            var dontDisplayOnPages = [
                'https://www.policytracker.com/login/',
                'https://www.policytracker.com/secure-account-info/',
                'https://www.policytracker.com/login/?reset=password',
                'https://www.policytracker.com/registration/',
                'http://www.policytracker.com/mobile-coverage-obligations-white-paper/',
                'https://www.policytracker.com/brochure-for-spectrum-research-service/',
                'https://www.policytracker.com/training-courses/registration-for-valuing-the-spectrum/',
                'https://www.policytracker.com/training-courses/registration-for-spectrum-auctions-masterclass/',
                'https://www.policytracker.com/training-courses/register-for-understanding-modern-spectrum-management/',
            ];

            var UrlIsExcludedUrls = dontDisplayOnPages.indexOf(document.URL) >= 0;
            var dontDisplayOnSecureAccount = document.URL.indexOf('www.policytracker.com/secure-account-info') >= 0 ||
                document.URL.indexOf('www.policytracker.com/newsletter-subscribers-management') >= 0 ||
                document.URL.indexOf('www.policytracker.com/research-service-subscribers-management') >= 0

            console.log('show!');
            if (!isPopupOpen && !isLoginPopupOpen && !UrlIsExcludedUrls && !dontDisplayOnSecureAccount) {
                $('.widget--form').fadeIn();
            }
            // $('.popup_spectrum_sign_in').addClass('show');
        }, 10000);
    }

    function timestamp() {
        var response = document.getElementById("g-recaptcha-response");
        if (response == null || response.value.trim() == "") {
            var elems = JSON.parse(document.getElementsByName("captcha_settings")[0].value);
            elems["ts"] = JSON.stringify(new Date().getTime());
            document.getElementsByName("captcha_settings")[0].value = JSON.stringify(elems);
        }
    };
    setTimeout(function (){
        setInterval(timestamp, 500);

    },1000)

    // $('<div class="g-recaptcha" data-sitekey="6LeEV2YUAAAAALY5n9j_h1HaV3hcv3wePgBFJsBH"></div><input type="hidden" class="hiddenRecaptcha " name="hiddenRecaptcha" id="hiddenRecaptcha">').insertBefore($('form.sellforce_forms').find('input[type="submit"]'));
    // $('<div class="g-recaptcha" data-sitekey="6LeEV2YUAAAAALY5n9j_h1HaV3hcv3wePgBFJsBH"></div>').insertBefore($('form.sellforce_forms').find('input[type="submit"]'));
    $("form.sellforce_forms").validate({
        ignore: ".ignore",
        rules: {
            // email: {
            //     required: true,
            //     email: true
            // },
            hiddenRecaptcha: {
                required: function () {

                    if (grecaptcha.getResponse() == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {},
        submitHandler: function (form) {
            // some other code
            // maybe disabling submit button
            // then:
            // form.submit();
            return true;
        }
    });


    // }

    //$('form.sellforce').submit(function (e) {
    //    e.preventDefault();
    //    console.log('form validation');
    //    //alert('Form validation start. In pogress...');
    //});

    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }
    
    // function recaptchaCallback() {
    //     $('#hiddenRecaptcha').valid();
    // };
}